import { outputFileFormat } from '@libs/enums';
import { CheckboxGroupField, FormField, TextStringField } from '@ps-smart-cp/ppfw-client';
import { outputOpsFieldConfig } from '../item-config';
import type { OutputOperations } from '../models';

interface OutputOperationsProps {
  outputOperations: OutputOperations;
  setOutputOperations: (obj: OutputOperations) => void;
  errorFields?: string[];
}

export function OutputOps({ outputOperations, setOutputOperations, errorFields }: OutputOperationsProps) {
  return (
    <FormField>
      <CheckboxGroupField
        items={outputOpsFieldConfig}
        obj={outputOperations}
        setObj={setOutputOperations}
        prop="outputFileFormat"
        enumType={outputFileFormat.enum}
        enumNameConfig={outputFileFormat.nameConfig}
        errorFields={errorFields}
      />
      <TextStringField
        items={outputOpsFieldConfig}
        obj={outputOperations}
        setObj={setOutputOperations}
        prop="jobComment"
        errorFields={errorFields}
      />
    </FormField>
  );
}
